import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute('/hashtag/$id')({
	beforeLoad: () => {
		throw notFound()
	},
})
